module.exports = __webpack_public_path__ + "img/LTS_MTN_GDP1.44877a0d.gif";